import { render, staticRenderFns } from "./CaseManager.vue?vue&type=template&id=4c792b5c&scoped=true"
import script from "./CaseManager.vue?vue&type=script&lang=js"
export * from "./CaseManager.vue?vue&type=script&lang=js"
import style0 from "./CaseManager.vue?vue&type=style&index=0&id=4c792b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c792b5c",
  null
  
)

export default component.exports